import {environment} from '../../../environments/environment';
import {from, Observable} from 'rxjs';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {mergeMap} from 'rxjs/operators';
import {OktaService} from '../_services/okta.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private oktaService: OktaService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let headers = req.headers;
    if (req.method !== 'GET') {
      headers = headers.set('Content-type', 'application/json');
    }

    if (
      req.url.startsWith(environment.oktaConfig.url) ||
      req.url.startsWith(environment.urlWarp)
    ) {

      return from(this.oktaService.getCachedAccessToken()).pipe(
        mergeMap((token) => {
          headers = headers.set('Authorization', `Bearer ${token.accessToken.accessToken}`);
          const authRequest = req.clone({headers: headers});
          return next.handle(authRequest);
        }));

    } else {

      const authRequest = req.clone();
      return next.handle(authRequest);

    }
  }

}
